import { render, staticRenderFns } from "./index.vue?vue&type=template&id=624c0106&scoped=true&"
import script from "./index.vue?vue&type=script&setup=true&lang=ts&"
export * from "./index.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=624c0106&prod&scoped=true&lang=less&"
import style1 from "./index.vue?vue&type=style&index=1&id=624c0106&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624c0106",
  null
  
)

export default component.exports